module.exports = __webpack_public_path__ + "img/9788931006285.7f19eac1.jpg";